/**
 * Auth strategy for the Redux-backed hosts (web, mobile) — the one place the
 * react-query client's auth reads Redux (`userService`/`authService`), keeping
 * `api-client.ts` store-agnostic. Web sends the cookie; mobile sends a bearer.
 */

import authService, { REFRESH_RESULT } from '../services/auth.service';
import userService from '../services/user.service';
import { REGIONS } from '../constants/region.constants';
import { type ApiAuthStrategy } from './api-client';

interface ReduxAuthStrategyOptions {
  useBearer: boolean;
}

export const createReduxAuthStrategy = ({
  useBearer,
}: ReduxAuthStrategyOptions): ApiAuthStrategy => ({
  ...(useBearer ? { getAccessToken: () => userService.accessToken } : { withCredentials: true }),
  getRegion: () => userService.region ?? REGIONS.US,
  refresh: async () => (await authService.refreshToken()) === REFRESH_RESULT.SUCCESS,
});
